<!--
frontend-author:udayasankar,
backend-author: ,
page-name :Sales by Item.vue,
page-description :Sales by Item for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Item-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="6" lg="6" md="6" sm="6" class="px-0">
        <GlobalDateRangePicker
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event)"
          :fromDate="from_date"
          :toDate="to_date"
        />
      </b-col>
      <b-col xl="6" lg="6" md="6" sm="6" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="la la-download mx-2"></span>Export Refund History
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4 class="fw-semi-bold">Refund History</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>
          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->
              <thead class="tbl-col">
                <tr>
                  <th style="width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'applieddate'} }"
                    >
                      Date
                      <small class="text-muted" v-if="label == 'applieddate'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'ref_no'} }"
                    >
                      Reference No
                      <small class="text-muted" v-if="label == 'ref_no'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'transaction'} }"
                    >
                      Txn
                      <small class="text-muted" v-if="label == 'transaction'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:160px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'cus_name'} }"
                    >
                      Customer
                      <small class="text-muted" v-if="label == 'cus_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:150px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'method_name'} }"
                    >
                      Mode
                      <small class="text-muted" v-if="label == 'method_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:160px !important">Notes</th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc',label:'amount'} }"
                    >
                      Amount
                      <small class="text-muted" v-if="label == 'amount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="7" class="text-center">No data to display</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(item,index) in lists" :key="index">
                    <td>{{ getDateFormat(item.applieddate) }}</td>
                    <td>{{ item.ref_no }}</td>
                    <td style="width:140px !important">
                      <span class="text">
                        <router-link
                          v-if="RoutePermission(
                                    true,(item.type == 'retainer' ? 'RetainerInvoiceView' :  item.type == 'credit' ? 'CreditView' : 'PaymentView'))"
                          :to="{ name : (item.type == 'retainer' ? 'RetainerInvoiceView' :  item.type == 'credit' ? 'CreditView' : 'PaymentView'),params:{id : item.id} }"
                        >{{ item.transaction }}</router-link>
                        <template v-else>{{ item.transaction }}</template>
                      </span>
                    </td>
                    <td style="width:160px !important">
                      <span class="text">{{ item.cus_name }}</span>
                    </td>
                    <td>{{ item.method_name }}</td>
                    <td style="width:160px !important">
                      <span class="text">{{ item.notes }}</span>
                    </td>
                    <td
                      class="text-right"
                    >{{ orgCurrencySymbol+" "+Number(item.amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                  <tr>
                    <td colspan="6" class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>

                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_refund).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0||arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav v-if="lists.length > 0" class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,show_by:$route.query.show_by,sort:sort,label:label} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count,show_by:$route.query.show_by,sort:sort,label:label} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,show_by:$route.query.show_by,sort:sort,label:label} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,show_by:$route.query.show_by,sort:sort,label:label } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count,show_by:$route.query.show_by,sort:sort,label:label } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RefundHistoryReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,show_by:$route.query.show_by,sort:sort,label:label } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Refund History'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Item  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import $ from "jquery";
import { formatDate } from "@/mixins/formatDate";

function getSalesByRefundHistory(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchRefundHistoryLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "SalesProduct",
  components: {
    DatePicker
  },
  mixins: [formatDate, scrollTable],
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        Date: "applieddate",
        Ref: "ref_no",
        Txn: "transaction",
        Customer: "cus_name",
        Mode: "method_name",
        Notes: "notes",
        Amount: "amount"
      },
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      Selected: "",
      org_name: this.$AppDetails.organization.comp_name || ""
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchRefundHistoryExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,
          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },
    selectDate(val, index) {
      this.items[index].value =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    closeModal(id) {
      this.$refs[id].hide();
    },
    getDateRange(event) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date
        }
      });
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    }
  },
  created() {
    // this.from_date =
    //   this.$route.query.from_date || this.formatDate(moment().startOf("month"));
    // this.to_date =
    //   this.$route.query.to_date || this.formatDate(moment().endOf("month"));
    if (
      Object.entries(this.$route.query).length === 0 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date
        }
      });
    }
  },

  beforeRouteEnter(routeTo, routeFrom, next) {
    getSalesByRefundHistory(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    getSalesByRefundHistory(routeTo, next);
  },
  computed: {
    ...mapState({
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      group_total_amount: state => state.reports.group_total_amount,
      export: state => state.reports.export
    }),
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"])
  }
};
</script>
<!--  Sales by Item style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
</style>